export default {
  data() {
    return {
      rules: {
        required: v =>
          (v !== null && v !== undefined && v !== '' && (!Array.isArray(v) || v.length > 0)) || 'Obligatorio',
        email: v =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || 'Formato email incorrecto',
        min: n => v => v == null || v.length >= n || 'Min. ' + n + ' caracteres',
        max: n => v => v == null || v.length <= n || 'Max. ' + n + ' caracteres'
      }
    }
  }
}
